/**
 * Must stay above the backend's own ceiling so a slow-but-successful response
 * is never turned into a client-side failure.
 *
 * TODO(4.3): provisional, not a confirmed number — re-derive with the
 * `change_data_capture` owners once the upstream ceiling is raised.
 */
export const REQUEST_TIMEOUT_MS = 120_000;
